import { Link } from "react-router-dom";
import { topics } from "@/mocks/manga";

export default function DiscussionSection() {
  const hot = topics.filter((t) => t.hot).slice(0, 4);

  return (
    <section className="bg-background-50 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <p className="text-xs font-bold tracking-wide text-primary-600">COMMUNITY</p>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">社区热门讨论</h2>
            <p className="mt-2 text-sm text-foreground-600">和你一起追漫的人，都在聊什么</p>
          </div>
          <Link to="/discussion" className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
            去社区逛逛 <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {hot.map((topic) => (
            <Link
              key={topic.id}
              to="/discussion"
              className="group flex items-start gap-4 rounded-2xl bg-background-100 p-4 transition-colors hover:bg-background-200"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-chat-3-line text-lg" aria-hidden="true"></i>
              </span>
              <div className="min-w-0">
                <h3 className="line-clamp-2 text-sm font-bold text-foreground-950 group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-foreground-600">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">{topic.group}</span>
                  <span>{topic.replies} 回复</span>
                  <span className="hidden sm:inline">{topic.author} · {topic.time}</span>
                </div>
              </div>
              {topic.hot && (
                <span className="ml-auto flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-bold text-accent-600">
                  <i className="ri-fire-fill" aria-hidden="true"></i> 热门
                </span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}